import { Navigate, type RouteObject, useParams } from "react-router";
import type { AppModule } from "../types";
import { s } from "./strings";

function TabAlias() {
  const { tab = "requests" } = useParams();
  return <Navigate replace to={`/time-off#${tab}`} />;
}

const page = () => import("./pages/TimeOffPage");
const title = { title: s.pageTitle };

const routes: RouteObject[] = [
  { path: "/time-off", handle: title, lazy: () => page().then((m) => ({ Component: m.TimeOffPage })) },
  { path: "/time-off/policy/new", handle: title, lazy: () => page().then((m) => ({ Component: m.NewPolicyPage })) },
  // The edit modal opens from the policies list; the route lands there (routes.md "Create/Edit policy page").
  { path: "/time-off/policy/edit/:policyId", handle: title, element: <Navigate replace to="/time-off#policies" /> },
  {
    path: "/time-off/import-holidays",
    handle: title,
    lazy: () => page().then((m) => ({ Component: m.ImportHolidaysPage })),
  },
  // TOIL is not built yet (REQUESTS.md / handoff knownGaps); its routes land on the policies view.
  { path: "/time-off/toil/new", handle: title, element: <Navigate replace to="/time-off#policies" /> },
  { path: "/time-off/toil/edit/:toilId", handle: title, element: <Navigate replace to="/time-off#policies" /> },
  // Aliases from older specs and Clockify's Free-plan promo route (routes.md redirects).
  { path: "/timeoff", element: <Navigate replace to="/time-off#requests" /> },
  { path: "/timeoff/toil/new", element: <Navigate replace to="/time-off/toil/new" /> },
  { path: "/timeoff/:tab", element: <TabAlias /> },
  { path: "/promo/time-off", element: <Navigate replace to="/time-off#requests" /> },
];

export const timeOffModule: AppModule = {
  name: "time-off",
  routes: { shell: routes },
  sidebar: [
    {
      id: "TIME_OFF",
      label: "Time off",
      path: "/time-off#requests",
      icon: "time-off",
      alt: "View Time off",
      activePrefixes: ["/time-off"],
    },
  ],
};
